import React, { useEffect } from "react";
import { useCreateUserWithEmailAndPassword } from "react-firebase-hooks/auth";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import auth from "../../firebase.init";
import LoadingSpinner from "../../Shared/LoadingSpinner";

const Registration = () => {
  const [createUserWithEmailAndPassword, user, loading] =
    useCreateUserWithEmailAndPassword(auth);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const email = data.email;
    const password = data.password;
    createUserWithEmailAndPassword(email, password);
  };

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  if (loading) {
    return <LoadingSpinner></LoadingSpinner>;
  }
  return (
    <div className="flex justify-center items-center lg:my-20 my-10">
      <div className="glass w-full md:w-3/6 lg:w-2/6 p-10 rounded-lg">
        <h5 className="text-3xl font-bold text-center">Registration Form</h5>
        <div className="my-4">
          <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
            <label className="font-bold mt-2">Name -</label>
            <input
              className="border-2 border-indigo-500 w-full rounded-md py-1 px-2"
              {...register("name", {
                required: {
                  value: true,
                  message: "Name required",
                },
              })}
            />
            <label>
              {errors.Email?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.Email.message}
                </span>
              )}
            </label>
            <label className="font-bold mt-2">Email -</label>
            <input
              className="border-2 border-indigo-500 w-full rounded-md py-1 px-2"
              {...register("email", {
                required: {
                  value: true,
                  message: "Input Password",
                },
                pattern: {
                  value: /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/,
                  message: "Input a valid password",
                },
              })}
            />
            <label>
              {errors.Email?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.Email.message}
                </span>
              )}
              {errors.Email?.type === "pattern" && (
                <span className="label-text-alt text-red-500">
                  {errors.Email.message}
                </span>
              )}
            </label>
            <label className="font-bold mt-2">Password -</label>
            <input
              className="border-2 border-indigo-500 w-full rounded-md py-1 px-2"
              {...register("password", {
                required: {
                  value: true,
                  message: "Password is required",
                },
                minLength: {
                  value: 6,
                  message: "Password must have 6 character",
                },
              })}
            />
            <label className="label">
              {errors.Password?.type === "required" && (
                <span className="label-text-alt text-red-500">
                  {errors.Password.message}
                </span>
              )}
              {errors.Password?.type === "minLength" && (
                <span className="label-text-alt text-red-500">
                  {errors.Password.message}
                </span>
              )}
            </label>
            <Link to="/login">Already have an account?</Link>
            <input
              className="font-bold rounded-md my-4 p-1 text-white bg-indigo-500"
              type="submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default Registration;
